module.exports = __webpack_public_path__ + "static/media/quickbooks.fcda79e8.png";